export enum Verb {
    Put = 'Put',
    Post = 'Post',
    Get = 'Get',
    Delete = 'Delete',
    Patch = 'Patch'
}